// Third party
import { merge } from "lodash";

// Components
import TextFieldOverrides from "./TextFieldOverrides";
import SelectOverrides from './SelectOverrides';
import DatePickerOverrides from './DatePickerOverrides';

export default function ComponentsOverrides() {
  return merge(TextFieldOverrides(), SelectOverrides(), DatePickerOverrides());
}
